<template>
<div class="animated fadeIn">    
    <b-card header-tag="header">
      <div slot="header">
        <i class="icon-screen-smartphone"></i> Terminais - Utilização       
      </div>
      <b-card-body>
        <div class="form-row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Empresas</label>
              <model-list-select
                :list="sellers.data"
                option-value="id"
                option-text="name"
                v-model="searchModel.sellerId"
                placeholder="Digite o nome da empresa"
                @searchchange="searchSellers"
              ></model-list-select>
            </div>
          </div>
          <div class="col-md-2">
            <base-input
              label="Digite o serial number"
              v-model="searchModel.serialNumber"
              v-on:keyup.enter="searchModel.serialNumber"
              placeholder
            />
          </div>          
          <div class="col-md-2">
            <div class="form-group">
              <label for="exampleFormControlSelect2">Modelo</label>
              <select :class="{'custom-select': true}" v-model="searchModel.modelId">
                <option v-for="(s, index) in deviceModelList" :key="index" :value="s.id">{{s.name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Dias sem uso</label>
              <select :class="{'custom-select': true}" v-model="searchModel.daysWithoutTransaction">
                <option v-for="(s, index) in daysWithoutTransactionsList" :key="index" :value="s.id">{{s.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <b-row>
          <b-col md="6" class="my-1">
            <b-form-group label-cols-sm="0" label class="mb-0">
              <b-input-group>
                <b-input-group-append>
                  <b-button @click="search" variant="primary">Buscar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card>
      <b-row class="float-right">
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="0" label class="mb-0">
            <b-input-group>
                <b-input-group-append>                    
                    <b-button @click="exportToExcel" variant="primary">Exportar</b-button>                                    
                </b-input-group-append>
            </b-input-group>           
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        :items="result.data"
        :fields="fields"
        :striped="true"
        responsive
      >
        <template slot="lastTransactionDate" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
      </b-table>
      <nav>
        <b-pagination
          :total-rows="result.rowCount"
          :per-page.sync="result.pageSize"
          v-model="currentPage"
          prev-text="Voltar"
          next-text="Próximo"
          @change="pageIndexChanged"
          first-text="Primeiro"
          last-text="Último"
        />
      </nav>
    </b-card>        
</div>
</template>
<script>
import domainService from "../../../services/Devices/deviceService";
import sellerService from "../../../services/Customer/sellerService";
import deviceModelService from "../../../services/Devices/deviceModelService";
import listPage from "../../../mixins/listPage";
import { ModelListSelect } from "vue-search-select";
import moment from 'moment';
export default {
    components: {
      ModelListSelect
    },
    mixins: [listPage],
    data() {
      return {
        searchModel: {
          sellerId: null,
          serialNumber: "",
          modelId: null,
          daysWithoutTransaction: null,
          page: 1,
          pageSize: 0            
        },
        sellers: {
          data: [],
          query: ""
        },
        deviceModelList: [],
        daysWithoutTransactionsList: [],
        fields: [
          { key: "deviceModelName", label: "Modelo", sortable: false },
          { key: "serialNumber", label: "Serial Number", sortable: false },
          { key: "sellerName", label: "Empresa", sortable: false },
          { key: "sellerDocument", label: "Documento", sortable: false },
          { key: "daysWithoutTransactions", label: "Dias s/ utilização", sortable: false },
          { key: "lastTransactionDate", label: "Data ultima utilização", sortable: false }
        ],
        currentPage: 1
      };
    },
    created() {
      this.fetchDeviceModelData();
      this.fetchDaysWithoutTransactionsList();
    },
    methods: {
      formatDateTimeFields(value) {
        return value == null || value == '' || value == '0001-01-01T00:00:00' ? '' : moment(value).format('DD/MM/YYYY - HH:mm:ss');
      },
      searchSellers(newQuery) {
        if (newQuery == null || newQuery.length < 2) return;
        const self = this;
        this.showLoading();
        sellerService.all(newQuery).then(
          response => {
            self.sellers.data = response.status == 204 ? [] : response.data;            
            self.hideLoading();
          },
          () => {
            self.hideLoading();
          }
        );
      },
      fetchDeviceModelData() {
        const self = this;
        this.showLoading();
        deviceModelService.all().then(
          response => {
            self.deviceModelList = response.status == 204 ? [] : response.data;
            self.deviceModelList.unshift({ id: null, name: "Selecione um modelo" });
            self.hideLoading();
          },
          error => {
            self.showError(error.response.data.result.errors[0].description);
            self.hideLoading();
          }
        );
      },
      fetchDaysWithoutTransactionsList() {
        this.daysWithoutTransactionsList.unshift({ id: null, name: "Selecione" });
        for (let index = 0; index < 16; index++) {
          this.daysWithoutTransactionsList.push({ id: index, name: `${index} dia(s)` });
        }
      },
      fetchData(page) {
        const self = this;
        this.searchModel.page = page;
        this.showLoading();            
        domainService.findAllUsage(this.searchModel).then(
          response => {
            self.$data.result =
              response.status == 204 ? self.getEmptyResult() : response.data;
            self.hideLoading();
          },
          () => {
          self.hideLoading();
          }
        );
      },
      pageIndexChanged(page) {
        this.currentPage = page;
        this.fetchData(page);
      },
      exportToExcel() {
        const self = this;
        this.showLoading();
        domainService.findAllUsageExport(this.searchModel).then(
          (response) => {
            window.open(response);
            self.hideLoading();
          },
          () => {
            self.hideLoading();
          }
        );      
      }
    }
}
</script>